<div class="activity-details solo">
    <c-auto-form config="assumeOwnership.autoFormConfig"></c-auto-form>
</div>